
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mendable-api/ingestionStatus",
      function () {
        return require("private-next-pages/mendable-api/ingestionStatus.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mendable-api/ingestionStatus"])
      });
    }
  